import { businessInfo, trustPoints } from "@/mocks/home";
import { useBooking } from "@/pages/home/components/BookingModal";

export default function Hero() {
  const { openBooking } = useBooking();

  return (
    <section id="inicio" className="relative w-full overflow-hidden">
      <div className="absolute inset-0 w-full h-full">
        <img
          src="https://readdy.ai/api/search-image?query=Bright%20airy%20modern%20clinical%20laboratory%20interior%20with%20soft%20natural%20light%2C%20teal%20turquoise%20and%20deep%20navy%20blue%20tones%2C%20clean%20minimalist%20hygienic%20calm%20atmosphere%2C%20blurred%20abstract%20medical%20equipment%20in%20the%20background%2C%20editorial%20photography%2C%20warm%20welcoming%20and%20professional%20mood&width=1920&height=1080&seq=anedan-hero-main&orientation=landscape&nocache=true"
          alt="Interior limpio y luminoso del Laboratorio Clínico ANEDAN"
          title="Laboratorio Clínico ANEDAN en Tlalnepantla"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-foreground-950/70 via-foreground-950/55 to-foreground-950/75"></div>
      </div>

      <div className="relative z-10 w-full px-4 md:px-8 pt-32 md:pt-40 pb-16 md:pb-24">
        <div className="max-w-4xl mx-auto text-center animate-fade-up">
          <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-background-50/15 border border-background-100/30 backdrop-blur-sm mb-6">
            <span className="flex items-center gap-1 text-accent-300">
              {[0, 1, 2, 3, 4].map((i) => (
                <i key={i} className="ri-star-fill text-sm"></i>
              ))}
            </span>
            <span className="text-xs md:text-sm text-background-50 font-medium tracking-wide">
              {businessInfo.rating} en Google · reseñas reales
            </span>
          </div>

          <h1 className="font-heading text-4xl md:text-6xl lg:text-7xl font-semibold text-background-50 leading-[1.05] tracking-tight">
            Precisión médica con
            <span className="block text-primary-300 mt-1">trato profundamente humano</span>
          </h1>

          <p className="mt-6 text-base md:text-lg text-background-100/90 leading-relaxed max-w-2xl mx-auto">
            En <strong className="font-semibold text-background-50">Laboratorio Clínico ANEDAN</strong> cuidamos
            tu salud con análisis clínicos y ultrasonido de confianza, precios accesibles y un equipo que te
            escucha con paciencia. Un espacio limpio, seguro e inclusivo en Tlalnepantla.
          </p>

          <div className="mt-9 flex flex-col sm:flex-row items-center justify-center gap-3 md:gap-4">
            <button
              type="button"
              onClick={openBooking}
              className="w-full sm:w-auto flex items-center justify-center gap-2 px-7 py-4 rounded-md bg-primary-500 text-background-50 text-base font-semibold hover:bg-primary-600 transition-colors duration-200 whitespace-nowrap cursor-pointer"
            >
              <i className="ri-calendar-check-line text-lg"></i>
              Agenda tu cita
            </button>
            <a
              href="#servicios"
              className="w-full sm:w-auto flex items-center justify-center gap-2 px-7 py-4 rounded-md bg-background-50/10 border border-background-100/40 text-background-50 text-base font-semibold hover:bg-background-50/20 backdrop-blur-sm transition-colors duration-200 whitespace-nowrap cursor-pointer"
            >
              Conoce nuestros servicios
              <i className="ri-arrow-right-line"></i>
            </a>
          </div>

          <div className="mt-8 flex flex-wrap items-center justify-center gap-x-6 gap-y-3 text-sm text-background-100/85">
            <span className="flex items-center gap-2">
              <i className="ri-phone-fill text-primary-300"></i>
              {businessInfo.phoneDisplay}
            </span>
            <span className="hidden sm:block w-px h-4 bg-background-100/30"></span>
            <span className="flex items-center gap-2">
              <i className="ri-time-line text-primary-300"></i>
              {businessInfo.hours}
            </span>
            <span className="hidden sm:block w-px h-4 bg-background-100/30"></span>
            <span className="flex items-center gap-2">
              <i className="ri-map-pin-2-line text-primary-300"></i>
              Tlalnepantla, Edomex
            </span>
          </div>
        </div>
      </div>

      <div className="relative z-10 w-full px-4 md:px-8 pb-12">
        <div className="max-w-5xl mx-auto flex flex-wrap items-center justify-center gap-x-8 gap-y-4 md:gap-x-12">
          {trustPoints.map((point) => (
            <div key={point.label} className="flex items-center gap-2 text-background-100/80">
              <i className={`${point.icon} text-lg text-accent-300`}></i>
              <span className="text-xs md:text-sm font-medium whitespace-nowrap">{point.label}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}